import React from "react";
import { Link } from "react-router-dom";

export default function Partners() {
    return (
        <div className="container">
            <div className="home-container">
                <h1>Партнёрки от Raytolfas</h1>
            </div>

            <div className="content-container">
            <img src="https://nztcdn.com/files/35bd9af5-8fc6-49bb-878d-6868e2f2ba3b.webp" className="img-contents" alt="alt-img" />
                <h1>EasyLiker</h1>
                <Link className="Link-button-header" to="https://easyliker.ru/register?ref=MIXITOSIK">Перейти</Link>
            </div>

            <div className="content-container">
                <img src="https://www.visnuk.com.ua/wp-content/uploads/2024/02/1win.webp" className="img-contents" alt="alt-img" />
                <h1>1WIN-Partners</h1>
                <Link className="Link-button-header" to="https://1win.run/?p=HEpe">Перейти</Link>
            </div>

            <div className="content-container">
                <h1>X-Partners</h1>
                <Link className="Link-button-header" to="https://xpartners.one/sub=0wq7N66rJT">Перейти</Link>
            </div>

            <div className="content-container">
                <img src="https://my.hosting-minecraft.pro/index.php?rp=/images/kb/65_Hosting-Minecraft_banner_468-60-2.jpg" alt="468x60 Banner" />
                <h1>Hosting-Minecraft</h1>
                <Link className="Link-button-header" href="https://my.hosting-minecraft.pro/aff.php?aff=7125" target="_blank">Перейти</Link>
            </div>
        </div>
    );
}
